import { TEMPLATE_VARIABLES } from "@lib/templateVariables";
import { Braces, ChevronDown, ChevronRight } from "lucide-react";
import { useState } from "react";

interface TemplateVariablePanelProps {
  templateType: string;
  onInsert: (variable: string) => void;
}

export function TemplateVariablePanel({ templateType, onInsert }: TemplateVariablePanelProps) {
  const [expanded, setExpanded] = useState(true);
  const variables = TEMPLATE_VARIABLES[templateType];

  if (!variables || variables.length === 0) {
    return null;
  }

  return (
    <div className="rounded-md border border-border bg-card-alt">
      <button
        type="button"
        onClick={() => setExpanded(!expanded)}
        className="flex w-full items-center gap-2 px-3 py-2 text-xs font-semibold uppercase tracking-wide text-text-muted hover:text-text-primary"
      >
        {expanded ? <ChevronDown size={14} /> : <ChevronRight size={14} />}
        <Braces size={14} />
        Available Variables
      </button>

      {expanded && (
        <div className="border-t border-border px-3 py-2">
          <div className="flex flex-wrap gap-1.5">
            {variables.map((v) => (
              <button
                key={v.variable}
                type="button"
                onClick={() => onInsert(v.variable)}
                title={v.description}
                className="inline-flex items-center rounded bg-surface px-2 py-1 font-mono text-xs text-accent hover:bg-accent hover:text-white transition-colors"
              >
                {`{{${v.variable}}}`}
              </button>
            ))}
          </div>
          <p className="mt-2 text-xs text-text-faint">
            Click a variable to insert it at the cursor.
          </p>
        </div>
      )}
    </div>
  );
}
